import { initializePaddle } from "@paddle/paddle-js";
import { api, apiConfig } from "../components/api/api";

const isPaddle =
  apiConfig.payment_gateway === "PADDLE" ||
  apiConfig.payment_gateway === "PADDLE_SANDBOX";

const getUpdatePaymentMethodTransaction = ({ subscriptionId, isSandbox }) => {
  // console.log("Get Plugins");
  const { ajax } = api;

  return new Promise((success, fail) => {
    ajax("getUpdatePaymentMethodTransactionPaddle", {
      noWorker: true,
      url: apiConfig.appUrl,
      type: "GET",
      params: { subscriptionId, isSandbox },
    })
      .then(success)
      .catch(fail);
  });
};

// Paddle accepts a fixed list of checkout locales, and rejects anything else
// rather than falling back. Our language picker offers "zh", which Paddle
// spells "zh-Hans" — passing it through untouched would break the checkout
// for Chinese users. Anything unrecognised drops to English.
const PADDLE_LOCALES = [
  "ar", "da", "de", "en", "es", "fr", "it", "ja", "ko", "nl",
  "no", "pl", "pt", "ru", "sv", "tr", "zh-Hans", "zh-Hant",
];

const paddleLocale = (locale) => {
  if (!locale) return undefined;
  if (PADDLE_LOCALES.includes(locale)) return locale;
  if (locale === "zh") return "zh-Hans";
  const base = String(locale).split("-")[0];
  return PADDLE_LOCALES.includes(base) ? base : "en";
};

const paddleSettings = (settings) => {
  if (!settings) return undefined;
  const locale = paddleLocale(settings.locale);
  return locale ? { ...settings, locale } : settings;
};

export const paddleCheckout = ({
  items,
  transactionId,
  discountCode,
  customer,
  updatePaymentMethodSubscription,
  subscriptionId,
  customData,
  onComplete,
  onClose,
  isSandbox,
  settings,
  spectreUserId,
}) => {
  if (isPaddle) {
    // Stamp who this checkout belongs to. The Paddle webhook has no other
    // way to tie an event back to a Spectre account: without it, it has to
    // guess from customer_id, and an add-on purchase can end up overwriting
    // the main subscription row.
    const checkoutCustomData = {
      ...(customData || {}),
      ...(spectreUserId ? { spectreUserId } : {}),
      spectreEnv: isSandbox ? "sandbox" : "live",
      catalogVersion: "2",
    };

    const paddleCheckoutAction = async (payload) => {
      const Paddle = await initializePaddle({
        token: apiConfig.paddle_client_side_token,
        environment: isSandbox ? "sandbox" : "production",
        eventCallback: (event) => {
          // console.log("Paddle event", event);
          if (event.name === "checkout.completed") {
            // console.log("Checkout complete...");
            if (onComplete) {
              onComplete(event);
            }
          } else if (event.name === "checkout.closed") {
            // console.log("Checkout close...");
            if (onClose) {
              onClose(event);
            }
          }
        },
      });

      Paddle?.Checkout.open(payload);
    };

    if (!updatePaymentMethodSubscription) {
      if (transactionId) {
        paddleCheckoutAction({
          transactionId,
          settings: paddleSettings(settings),
        });
      } else {
        paddleCheckoutAction({
          items,
          discountCode,
          customer,
          customData: checkoutCustomData,
          settings: paddleSettings(settings),
        });
      }
    } else {
      getUpdatePaymentMethodTransaction({
        subscriptionId,
        isSandbox,
      }).then((transaction) => {
        paddleCheckoutAction({
          transactionId: transaction.id,
          customer: {
            id: transaction.customer_id,
            address: {
              id: transaction.address_id,
            },
          },
          settings: paddleSettings(settings),
        });
      });
    }
  }
};
